import clsx from 'clsx';
import { FunctionComponent } from 'react';
import Item from './Item';
import { Payment } from '@spike/payments-model';
import styles from './Items.module.scss';

interface ItemsProps {
    payment: Payment;
    className?: string;
}

export const Items: FunctionComponent<ItemsProps> = props => {
    return (
        <div className={clsx(styles.container, props.className)}>
            <div className={styles.body}>
                <Item
                    key={props.payment.uuid}
                    description={`Payment ${props.payment.paidAt.format('MM/DD/YYYY')} (${props.payment.status.name})`}
                    price={props.payment.amount}
                />
                {props.payment.refunds.map(refund => (
                    <Item
                        refund={true}
                        key={refund.uuid}
                        description={`Refund ${refund.refundDate.format('MM/DD/YYYY')} (${refund.status.name})`}
                        price={refund.amount}
                    />
                ))}
            </div>
            <div className={styles.footer}>
                <p className={styles.footerLabel}>Balance</p>
                <p className={styles.footerAmount}>
                    $
                    {Number(props.payment.balance).toLocaleString('en-US', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    })}
                </p>
            </div>
        </div>
    );
};

export default Items;
